import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTestBuyTagFilledIn = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 21,
	height: 21,
	fill: "none",
	viewBox: "0 0 21 21",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#111",
		fillRule: "evenodd",
		d: "M10.1 1 2.2 2.1l-1.3 8 10.4 10.3 9.2-9.2L10.1 1Zm-2 7a1.5 1.5 0 1 0-2.2-2A1.5 1.5 0 0 0 8 8Z",
		clipRule: "evenodd"
	})
});
export default SvgTestBuyTagFilledIn;
